<template>
  <div
    v-if="!hide"
    class="Conversation"
    :class="{ '-expanded' : isExpanded, 'panel' : isExpanded }"
  >
    <div
      v-if="isExpanded"
      class="panel-heading conversation-heading -sticky"
      :class="{ '-with-back': isPage }"
    >
      <button
        v-if="isPage"
        class="button-unstyled go-back-button"
        :title="$t('nav.back')"
        :aria-label="$t('nav.back')"
        @click="goBack"
      >
        <FAIcon
          fixed-width
          icon="chevron-left"
        />
      </button>
      <h1 class="title">
        <RichContent
          v-if="conversation[0]?.summary_raw_html"
          :html="conversation[0].summary_raw_html"
          :emoji="conversation[0].emojis"
        />
        <template v-else>
          {{ $t('timeline.conversation') }}
        </template>
      </h1>
      <button
        v-if="collapsable"
        class="button-unstyled -link"
        @click.prevent="toggleExpanded"
      >
        {{ $t('timeline.collapse') }}
      </button>
    </div>
    <div
      v-if="isPage && !status"
      class="conversation-body"
      :ref="setBody"
      :class="{ 'panel-body': isExpanded }"
    >
      <PanelLoading v-if="!loadStatusError" />
      <p v-else>
        {{ $t('status.load_error', { error: loadStatusError }) }}
      </p>
    </div>
    <div
      v-else
      class="conversation-body"
      :ref="setBody"
      :class="{ 'panel-body': isExpanded }"
    >
      <div class="thread-body">
        <article>
          <Status
            v-for="status in shownConversation"
            :key="status.id"
            class="conversation-status status-fadein panel-body"
            :status-id="status.id"

            :expandable="!isExpanded"
            :focused="maybeFocused === status.id || maybeFocused === status.retweeted_status?.id"
            :inline-expanded="collapsable && isExpanded"
            :in-profile="inProfile"
            :in-conversation="isExpanded"
            :filter-place="filterPlace"
            :profile-user-id="profileUserId"

            @goto="setFocused"
            @toggle-expanded="toggleExpanded"
            @suspendable-state-change="onStatusSuspendStateChange"
          />
        </article>
      </div>
    </div>
  </div>
  <div
    v-else
    class="Conversation -hidden"
    :style="hiddenStyle"
  />
</template>

<script src="./conversation.js"></script>
<style src="./conversation.scss" />
